import { getTranslation } from 'common/react/utils/translations';

export const composeColumnData = (windowWidth) => {
    const isWebView =
        PULSE.core.url.getParam('webview') === 'true'
            ? true
            : false || window.IS_ARTICLE_API === true;

    // display less columns in webview and mobile
    if (
        isWebView ||
        (windowWidth ?? innerWidth) < PULSE.app.measurements.desktop
    ) {
        return [
            {
                Header: getTranslation('label.draftTracker.pick'),
                accessor: 'pick',
                sortDescFirst: true,
                disableSortBy: true
            },
            {
                Header: getTranslation('label.club'),
                accessor: 'club',
                disableSortBy: true
            },
            {
                Header: getTranslation('label.player'),
                accessor: 'player',
                disableSortBy: true
            }
        ];
    }

    return [
        {
            Header: getTranslation('label.draftTracker.pick'),
            accessor: 'pick',
            sortDescFirst: true,
            disableSortBy: true
        },
        {
            Header: getTranslation('label.club'),
            accessor: 'club',
            disableSortBy: true
        },
        {
            Header: getTranslation('label.player'),
            accessor: 'player',
            disableSortBy: true
        },
        {
            Header: getTranslation('label.stat.height'),
            accessor: 'height',
            disableSortBy: true
        },
        {
            Header: getTranslation('label.stat.weight'),
            accessor: 'weight',
            disableSortBy: true
        },
        {
            Header: getTranslation('label.stat.dateOfBirth'),
            accessor: 'dob',
            disableSortBy: true
        },
        {
            Header: getTranslation('label.from'),
            accessor: 'from',
            disableSortBy: true
        }
    ];
};
